module.exports = __webpack_public_path__ + "static/media/headquarter-blue-icon.70892fca.svg";